(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grip-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('grip-card-actions')) {
    class GripCardActions extends HTMLElement {
      #controller = null;

      connectedCallback() {
        this.#controller = new AbortController();
        this.addEventListener('click', this.#keepClickInCard, { signal: this.#controller.signal });
      }

      disconnectedCallback() {
        this.#controller?.abort();
      }

      /**
       * Horizon product cards navigate on any click that isn't on a button,
       * input, label or select. Keep clicks on the notify toggle and form
       * inside the card so they open the form instead of the product page.
       * @param {MouseEvent} event
       */
      #keepClickInCard = (event) => {
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('summary, .grip-notify')) event.stopPropagation();
      };
    }

    customElements.define('grip-card-actions', GripCardActions);
  }
  } catch(e) { console.error(e); }
})();

})();
